// src/store/slices/usersSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiUrl } from "../constants/apiUrl";

export const fetchUsers = createAsyncThunk(
  "users/fetchUsers",
  async (filters, thunkAPI) => {
    try {
      // const params = new URLSearchParams();
      const state = thunkAPI.getState(); // Access Redux state
      const response = await axios.get(
        `${apiUrl}/admin/clients`,
        {
          headers: {
            Authorization: `Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL25hbm9zb2Z0LnRlY2hub2xvZ3kvb3V0bGF3L2FwaS9hZG1pbi9hdXRoL2xvZ2luIiwiaWF0IjoxNzY5MjczMjEwLCJleHAiOjE4MDA4MDkyMTAsIm5iZiI6MTc2OTI3MzIxMCwianRpIjoiMHRmN1pyanNxVjdTTThweSIsInN1YiI6IjEiLCJwcnYiOiI2ZThkZTg4YTU4ZDMxNDFhYTk5Y2Q3NmExYmI0MzVlYzAwYzY4MDg0In0.GE5NJEYGF47pQaiARg0QEMVcO9UTsiVv1HChkZZhnWw`,
            // Authorization: `Bearer ${state.auth.userArray.access_token}`,
          },
        }
      );
console.log(response.data.data);

      return response.data.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.errors
          ? Object.values(error.response.data.errors)[0][0]
          : "حدث خطأ أثناء جلب العقارات"
      );
    }
  }
);
export const addUser = createAsyncThunk(
  "trainers/addUser",
  async (userData, thunkAPI) => {
    try {
      const state = thunkAPI.getState(); // Access Redux state

      const response = await axios.post(`${apiUrl}/admin/clients`, userData, {
        headers: {
          Authorization: `Bearer ${state.auth.userArray.access_token}`,
        },
      });
      console.log(response.data.data);
      
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || "فشل إضافة الصف");
    }
  }
);
export const updateUser = createAsyncThunk(
  "users/updateUser",
async ({ id, data }, thunkAPI) => {
    try {
      const state = thunkAPI.getState(); // Access Redux state

      const response = await axios.post(`${apiUrl}/admin/users/${id}`, data, {
        headers: {
          Authorization: `Bearer ${state.auth.userArray.access_token}`,
        },
      });
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || "فشل إضافة الصف");
    }
  }
);

const usersSlice = createSlice({
  name: "users",
  initialState: {
    list: [],
status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
       state.status = "loading";
        state.error = null;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.list = action.payload;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
       state.status = "failed";
        state.error = action.payload;
      }).addCase(addUser.pending, (state) => {
       state.status = "loading";
        state.error = null;
      })
      .addCase(addUser.fulfilled, (state, action) => {
      state.status = "succeeded";
        state.list.push(action.payload);
      })
      .addCase(addUser.rejected, (state, action) => {
       state.status = "failed";
        state.error = action.payload;
      }).addCase(updateUser.pending, (state) => {
       state.status = "loading";
        state.error = null;
      })
      .addCase(updateUser.fulfilled, (state, action) => {
      state.status = "succeeded";
        state.list.push(action.payload);
      })
      .addCase(updateUser.rejected, (state, action) => {
       state.status = "failed";
        state.error = action.payload;
      })

  },
});

export default usersSlice.reducer;
